var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiLogo = function SvgAiLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_98552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1731_98552",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 19,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7625C0.0134715 15.751 0.0145078 15.7352 0.0176166 15.7184C0.038342 15.5974 0.0694301 15.4827 0.125388 15.3743C1.98964 11.856 3.77824 8.29561 5.64559 4.77833C5.87358 4.34801 6.05389 3.98714 6.42695 3.66203C7.69741 2.55518 9.66007 2.93921 10.4291 4.4406L12.6581 8.73225C13.3761 8.5134 14.0974 8.30824 14.8208 8.11044C15.5181 7.92 16.2684 7.69169 16.971 7.54649C17.6974 7.39604 18.2829 7.94946 18.1752 8.69647C17.5606 10.9891 16.9803 13.2932 16.3368 15.5763C15.9088 16.5096 14.6342 16.6001 14.0912 15.7173C14.057 15.6626 14.0259 15.5984 13.9948 15.5406C13.2477 14.1739 12.5658 12.7661 11.8363 11.39C11.7938 11.31 11.7492 11.231 11.7098 11.1501L11.6881 11.1353C10.2871 11.6561 8.93683 12.3011 7.62176 13.0134C5.75752 14.0224 3.93679 15.1377 2.14923 16.2781C1.87151 16.4549 1.46114 16.7853 1.14715 16.8378C0.698446 16.9115 0.245596 16.659 0.0787565 16.2287C0.0435234 16.1382 0.0321244 16.0435 0.00207249 15.952V15.7625H0ZM3.55026 13.067L5.4114 11.977C6.63835 11.2837 7.87669 10.6061 9.15649 10.019C9.68496 9.77704 10.2217 9.55923 10.7606 9.3435L8.68083 5.34018C8.44145 4.90564 7.80311 4.9088 7.5658 5.34333L3.6 12.9523L3.54923 13.0659L3.55026 13.067ZM15.827 9.90639L13.6062 10.5219L14.9678 13.1522L15.828 9.90743L15.827 9.90639Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1731_98552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4155 8.66169L-0.842529 14.7388L0.586487 17.468L11.8445 11.3898L10.4155 8.66064V8.66169Z",
    fill: "url(#paint0_linear_1731_98552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4145 4.45215L12.4995 8.71538L16.4965 16.3623L24.4115 12.099L20.4145 4.45215Z",
    fill: "url(#paint1_linear_1731_98552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56471 2.85815L7.73462 3.50311L8.1854 4.91401L8.78121 5.52951C8.78121 5.52951 12.9761 13.5994 15.0808 17.6543C15.4942 17.0009 15.9937 16.5443 16.4072 15.8909L13.6061 10.5219L12.5584 8.54176L10.4289 4.4416L10.174 3.55466L9.56471 2.85815Z",
    fill: "url(#paint2_linear_1731_98552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.507812 14.5746L6.39996 1.51978L9.67459 3.38941L4.1554 12.1021L-0.507812 14.5746Z",
    fill: "url(#paint3_linear_1731_98552)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7651 2.85823C18.8604 2.90873 18.8604 2.97186 18.8584 3.07076C18.8532 3.28644 18.8325 3.50424 18.8718 3.71887C18.9537 4.15972 19.2231 4.53743 19.5931 4.77206C19.6842 4.82993 19.9734 4.96144 20.0252 5.02352C20.0346 5.03509 20.0376 5.05087 20.048 5.0614V5.14662C20.0294 5.18133 20.0097 5.22027 19.9672 5.22974C19.8988 5.24552 19.7247 5.23289 19.6439 5.23184C19.6242 5.23184 19.6056 5.22237 19.5879 5.22237C18.9973 5.21711 18.4915 5.46752 18.1765 5.9799C18.1206 6.07144 17.9796 6.38813 17.9153 6.43337C17.8231 6.49755 17.7226 6.42075 17.7153 6.31554C17.7123 6.2724 17.7247 6.23873 17.7257 6.2019C17.7289 5.98306 17.7372 5.76001 17.6905 5.54537C17.6035 5.14135 17.3485 4.77732 17.0086 4.55532C16.8853 4.47535 16.6739 4.39434 16.5724 4.30912C16.4842 4.23547 16.5164 4.09343 16.6242 4.07765C16.7807 4.05451 16.9941 4.09659 17.163 4.08712C17.6915 4.05766 18.1517 3.74939 18.4201 3.29486C18.4874 3.18018 18.5475 3.02447 18.619 2.9203C18.6408 2.88874 18.6635 2.87822 18.6915 2.85718H18.7662L18.7651 2.85823Z",
    fill: "#0C80DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1731_98552",
    x1: 11.2363,
    y1: 15.4101,
    x2: 3.14025,
    y2: 12.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#034AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#034AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C80DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1731_98552",
    x1: 15.2716,
    y1: 21.0368,
    x2: 18.8041,
    y2: 8.26388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1731_98552",
    x1: 14.1833,
    y1: 13.935,
    x2: 9.45964,
    y2: 4.78894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ED6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E154FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1731_98552",
    x1: 2.39893,
    y1: 13.1984,
    x2: 7.22712,
    y2: 4.15793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C80DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E154FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_98552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai_logo.714c025f7e23ecbcdf95b8d7de5061ce.svg";